import { userResetPasswordSuccess, userResetPasswordError } from "./reducer";

import { passwordReset as passwordResetApi } from "../../../apiCalls/caller";

export const passwordReset = (user, history) => async (dispatch) => {
  try {
    let response;

    response = passwordResetApi(user);

    const data = await response;

    if (data.success) {
      window.location.href = data.data;
      dispatch(
        userResetPasswordSuccess(
          "Reset password has been successfully updated, please login again"
        )
      );
    } else {
      dispatch(userResetPasswordError(data));
    }
  } catch (forgetError) {
    dispatch(userResetPasswordError(forgetError));
  }
};
